import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { lumi } from '../lib/lumi'
import {LogIn, Globe, Lightbulb, TrendingUp} from 'lucide-react'

export default function Login() {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleGoogleLogin = async () => {
    setLoading(true)
    try {
      await lumi.auth.signIn()
    } catch (err: any) {
      console.error('Erro ao fazer login:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm">
          {/* Logo e Nome */}
          <div className="text-center mb-12">
            <img 
              src="https://static.lumi.new/94/94387bd69277769ec0567b4f6dbc1e0e.webp" 
              alt="Logo" 
              className="h-20 w-auto mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold text-gray-900">Unovalinks</h1>
            <p className="text-sm text-gray-500 mt-2">
              Crie propostas, feche contratos e receba pagamentos em minutos.
            </p>
          </div>

          {/* Bem-vindo */}
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Bem-vindo</h2>
            <p className="text-gray-600 text-sm">
              Entre para acessar seu painel
            </p>
          </div>

          {/* Botão Principal */}
          <button
            onClick={handleGoogleLogin}
            disabled={loading}
            className="w-full bg-[#DC2626] text-white py-4 rounded-lg font-semibold text-base hover:bg-[#B91C1C] transition-all shadow-lg shadow-red-500/20 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 mb-4"
          >
            <LogIn size={20} />
            {loading ? 'Conectando...' : 'Entra no painel ou criar minha conta'}
          </button>

          {/* Texto ajuda */}
          <p className="text-center text-gray-500 text-sm mb-6">
            Precisa de ajuda? Fale com o nosso suporte.
          </p>

          {/* Contato Suporte */}
          <div className="space-y-3 mb-4">
            <a
              href="https://wa.me/558199387-9157"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-[#DC2626] text-white py-3 rounded-lg font-semibold text-sm hover:bg-[#B91C1C] transition-colors flex items-center justify-center gap-2"
            >
              WhatsApp - Suporte
            </a>
            <button
              onClick={() => {
                navigator.clipboard.writeText('suporte.nexias.unovalinks@gmail.com')
                alert('E-mail copiado: suporte.nexias.unovalinks@gmail.com')
              }}
              className="w-full bg-gray-100 text-gray-700 py-3 rounded-lg font-semibold text-sm hover:bg-gray-200 transition-colors flex items-center justify-center gap-2"
            >
              📧 Copiar e-mail de suporte
            </button>
          </div>

          {/* Texto Social Proof */}
          <p className="text-center text-gray-600 text-sm mb-8">
            Usada por freelancer, agências e empresas do mundo todo.
          </p>

          {/* Features Cards */}
          <div className="grid grid-cols-3 gap-6 pt-6 border-t border-gray-200">
            <div className="flex flex-col items-center gap-2">
              <Globe className="text-[#DC2626]" size={32} />
              <span className="text-xs text-gray-700 font-medium">Global</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <Lightbulb className="text-[#DC2626]" size={32} />
              <span className="text-xs text-gray-700 font-medium">Inovação</span>
            </div>
            <div className="flex flex-col items-center gap-2">
              <TrendingUp className="text-[#DC2626]" size={32} />
              <span className="text-xs text-gray-700 font-medium">10x resultados</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
